export interface PendoData {
  id: string;
  visitorId: string;
  email: string;
  name: string;
  full_name: string;
  //TODO - check if we need those fields
  // planLevel: string;
  // 'Plan-Type': string;
  // Plan: string;
  // redirectV4: string;
  Role: string;
}

/**
 * Pendo script loader.
 * @param apiKey
 */
const loadPendo = apiKey => {
  (function(p, e, n, d, o) {
    let v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = o._q || [];
    // eslint-disable-next-line prefer-const
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
    for (w = 0, x = v.length; w < x; ++w) {
      (function(m) {
        o[m] =
          o[m] ||
          function() {
            // eslint-disable-next-line prefer-rest-params
            o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
          };
      })(v[w]);
    }
    // eslint-disable-next-line prefer-const
    y = e.createElement(n);
    y.async = true;
    y.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
    // eslint-disable-next-line prefer-const
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo', apiKey);
};

export const pendoInit = (data: PendoData) => {
  loadPendo('f34764d6-aef2-44b4-5a95-74ccf11d7d6e');

  if (!window.pendo) {
    return false;
  }
  try {
    window.pendo.initialize({
      visitor: {
        id: data.visitorId,
        email: data.email,
        name: data.full_name,
        Role: data.Role,
      },
      account: {
        id: data.id,
        name: data.full_name,
      },
    });
  } catch (e) {
    return false;
  }
  return true;
};
